export default __webpack_public_path__ + "assets/online.a878d243.svg";